import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(
  (theme) => ({
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: [0, 40, 0, 45],
      width: "100%",
      height: "100%",
    },
    logo: {
      height: 68,
      marginRight: 78,
    },
    nav: {
      flex: 1,
    },
    actions: {
      display: "flex",
      alignItems: "center",
    },
    action: {
      marginLeft: 40,
    },
    menuIconButton: {
      padding: 0,
    },
    buttonLink: {
      height: 38,
      color: theme.palette.primary.light,
      border: [1, "solid", theme.palette.secondary.main],
      display: "block",
      padding: 0,
      width: 115,
      textAlign: "center",
      borderRadius: 19,
      fontSize: theme.typography.pxToRem(18),
      lineHeight: theme.typography.pxToRem(36),
      willChange: "backgroundColor",
      transform: "opacity 0.1s cubic-bezier(0.25, 1, 0.5, 1)",
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    buttonLinkActive: {
      backgroundColor: theme.palette.secondary.main,
    },
    menuIcon: {
      fontSize: theme.typography.pxToRem(42),
    },
    searchIcon: {
      fontSize: theme.typography.pxToRem(42),
    },
  }),
  { name: "DesktopHeader" },
);
